import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

const MobileHomeSlider = ({ SliderMain }) => {
  // Use API data if available, don't show anything if empty
  const slides = SliderMain.length > 0 ? SliderMain : [];

  // Don't render anything if no slides
  if (slides.length === 0) {
    return null;
  }

  return (
    <div className="home-banner">
      <div className="page-banner">
        <Swiper
          modules={[Autoplay, Pagination]}
          pagination={{ clickable: true }}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          loop={true}
          slidesPerView={1}
          spaceBetween={10}
          className="mySwiper"
        >
          {slides.map((slider, i) => {
            const src = `${process.env.REACT_APP_API_URL}/storage/${slider.thubmnail}`;

            return (
              <SwiperSlide key={i}>
                <div className="swiper-inner">
                  <img
                    src={src}
                    alt={`banner-${i}`}
                    style={{
                      width: "100%",
                      display: "block",
                      borderRadius: "8px",
                      padding: "5px",
                    }}
                    loading="lazy"
                  />
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </div>
  );
};

export default MobileHomeSlider;
